<template>
	<div>

        <PropertyPopupEditor :id="showEdit" v-if="showEdit" v-on:close="closeEditor" />

		<v-client-table :columns="columns" :data="data" :options="options" ref="all" class="properties-table">
            <div slot="beforeFilter" class="intro">
                <h2>{{ $t('properties.overview.all.headline' )}}</h2>
            </div>
            <div slot="afterFilter" class="add-button">
                <div class="data-input select-field sorting" style="">
                    <div class="select-container">
                        <select v-model="sorting" v-on:change="setTableSorting('all', sorting)">
                            <option value="">{{ $t('sort.newest-first') }}</option>
                            <option value="10">{{ $t('sort.oldest-first') }}</option>
                            <option value="20">{{ $t('sort.address-ascending') }}</option>
                            <option value="30">{{ $t('sort.zipcode-ascending') }}</option>
                        </select>
                        <span class="arrow">
                            <SvgIcon icon="sort-icon" />
                        </span>
                    </div>
                </div>
                <form>
                    <div class="icon">
                        <SvgIcon icon="search" />
                    </div>
                    <input type="text" v-model="filterText" v-on:keyup="filterTable('all')" autofill="off" autocomplete="false" :placeholder="$t('search.filterplaceholder')">
                </form>
                <router-link disabled to="#" class="button green">
                    <SvgIcon icon="plus-circle" />
                    <span>{{$t('properties.new.button')}}</span>
                </router-link>
            </div>
            <!-- ADDRESS -->
            <div slot="address" class="data-label" :data-label="$t('properties.table.screenings.address')" slot-scope="props">
                <a v-if="props.row.link" :href="props.row.link">{{ props.row.address }} <span class="city-info"> {{ props.row.zipcode_city }}</span></a>
                <a v-else class="row-link" v-on:click="editProperty(props.row.id)">
                    <span>{{ props.row.address }} <span class="city-info"> {{ props.row.zipcode_city }}</span></span>
                </a>

            </div>
            <div slot="invitation_count" class="data-label" :data-label="$t('properties.table.properties.invitations')" slot-scope="props">
                {{ props.row.invitation_count }}
            </div>
            <div slot="contracts_count" class="data-label" :data-label="$t('properties.table.properties.contracts')" slot-scope="props">
                {{ props.row.contracts_count }}
            </div>
            <div slot="text_status" class="data-label" :data-label="$t('properties.table.properties.status')" slot-scope="props">
                {{ props.row.text_status }}
            </div>
            <a slot="more" slot-scope="props">
                <table-dropdown>
                    <li v-on:click="editProperty(props.row.id)">{{$t('properties.edit.button')}}</li>
                    <li v-on:click="deleteProperty(props.row.id)">{{$t('properties.delete.button')}}</li>
                </table-dropdown>
            </a>
        </v-client-table>

	</div>
</template>

<script>
    import Vue from 'vue';
    import {ClientTable} from 'vue-tables-2';
    import TableDropdown from './TableDropdown.vue';
    import SvgIcon from './Svg.vue';
    import PropertyPopupEditor from './PropertyPopupEditor.vue';
    import createEntity from "../mixins/create-entity";
    Vue.use(ClientTable);

	export default {
		props: [
			'data',
		],
        mixins: [createEntity],
        components:{
            TableDropdown,
            SvgIcon,
            PropertyPopupEditor,
        },
		data: () => ({
            showEdit: false,
            filterText: '',
            sorting: '',
            columns: ['address', 'zipcode_city', 'invitation_count', 'contracts_count', 'text_status', 'more'],
            options: {
                headings: {
                    address: 'Address',
                    city: 'City',
                    zipcode_city: '',
                    invitation_count: 'Screenings',
                    contracts_count: 'Contracts',
                    text_status: 'Rental Status',
                    more: 'More'
                },
                sortable: ['address', 'city', 'invitation_count'],
                filterable: ['address', 'city', 'text_status'],
                texts:{
                    filterPlaceholder: 'Search',
                    filter: '',
                    noResults: ''
                },

                childRowTogglerFirst: false,
                columnsClasses:{
                   address: 'address',
                   zipcode_city:    'city',
                   invitation_count: 'invitation-count',
                   contracts_count: 'contracts-count',
                   text_status: 'status',
                   more: 'more'
                },
                customSorting: {
                    oldFirst: function (descending) {
                        return function (b, a) {
                            return descending ? 1 : -1;
                        }
                    }
                }
            },
            links:{
                0: {
                    'link' : '#',
                    'title': 'link title'
                },
                1: {
                    'link' : '#',
                    'title': 'link title'
                }
            },
		}),
		methods: {
            closeEditor() {
                this.showEdit = false;
            },
            filterTable(ref, value) {
                this.$refs[ref].setFilter(this.filterText);
            },
            editProperty(id) {
                this.showEdit = id;
            },
            setTableSorting(ref, algo) {
                switch (String(algo)) {
                    case '':
                        this.$refs[ref].setOrder('oldFirst', true);
                        break;
                    case '10':
                        this.$refs[ref].setOrder('oldFirst', false);
                        break;
                    case '20':
                        this.$refs[ref].setOrder('address', true);
                        break;
                    case '30':
                        this.$refs[ref].setOrder('zipcode', true);
                        break;
                }
            },
            deleteProperty(id)
            {
                if (confirm(this.$t('properties.delete.confirmation.label'))) {
                    Vue.api.delete('/property/' + id, {}, {
                        callback: () => {
                            this.$store.commit('setSuccessBarMessage', this.$t('properties.deleted.label'));
                            this.$emit('refresh');
                        }
                    });
                }
            },
		},
		created() {
            this.options.headings.address = this.$t('properties.table.properties.address');
            this.options.headings.zipcode_city = this.$t('properties.table.properties.city');
            this.options.headings.invitation_count = this.$t('properties.table.properties.invitations');
            this.options.headings.contracts_count = this.$t('properties.table.properties.contracts');
            this.options.headings.text_status = this.$t('properties.table.properties.status');
            this.options.headings.more = this.$t('tables.more.label');
            this.options.texts.filterPlaceholder = this.$t('search.filterplaceholder');
            this.options.texts.noResults = this.$t('table.no-results.label');
		},
	}
</script>
